import { Menu } from 'lucide-react';
import AccountPopover from './AccountPopover';

interface DashboardNavbarProps {
  onOpenSidebar: () => void;
}

export default function DashboardNavbar({ onOpenSidebar }: DashboardNavbarProps) {
  return (
    <header className="fixed left-0 right-0 top-0 z-30 border-b border-slate-200 bg-white lg:left-[264px]">
      <div className="flex h-14 items-center justify-between gap-4 px-4 sm:px-6">
        <button
          type="button"
          onClick={onOpenSidebar}
          className="rounded-lg p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700 lg:hidden"
          aria-label="Ouvrir le menu"
        >
          <Menu className="h-5 w-5" />
        </button>
        <div className="flex-1" />
        <div className="flex items-center gap-2">
          <AccountPopover />
        </div>
      </div>
    </header>
  );
}
